import { render } from "./MonitorApps.vue?vue&type=template&id=2c2652f5&scoped=true"
import script from "./MonitorApps.vue?vue&type=script&lang=js"
export * from "./MonitorApps.vue?vue&type=script&lang=js"

import "./MonitorApps.vue?vue&type=style&index=0&id=2c2652f5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2652f5"]])

export default __exports__